if (!customElements.get('poto-star-rating')) {
  customElements.define('poto-star-rating', class extends HTMLElement {
    static observedAttributes = ['data-hide-empty'];

    setHidden(hidden) {
      this.hidden = hidden;
      const block = this.closest('.shopify-block');
      if (block && block !== this) block.hidden = hidden;
    }

    attributeChangedCallback(name, previous) {
      if (name === 'data-hide-empty' && previous !== null && this.isConnected) this.connectedCallback();
    }

    async connectedCallback() {
      this.setHidden(true);
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        if (!/^\/(apps|a|community|tools)\/[a-zA-Z0-9_-]+$/.test(this.dataset.endpoint) || !/^\d+$/.test(this.dataset.product)) return;
        const url = new URL(this.dataset.endpoint, location.origin);
        url.searchParams.set('product', this.dataset.product);
        url.searchParams.set('view', 'rating');
        const response = await fetch(url, { signal: this.controller.signal, cache: 'no-store' });
        if (!response.ok) return;
        const { total, average } = await response.json();
        if (!Number.isInteger(total) || total < 0 || (total && (!Number.isFinite(average) || average < 1 || average > 5))) return;
        if (!total && this.dataset.hideEmpty !== 'false') return;
        const link = document.createElement('a');
        link.href = `#poto-reviews-${this.dataset.product}`;
        link.setAttribute('aria-label', total ? `${average.toFixed(2)} out of 5, ${total} ${total === 1 ? 'review' : 'reviews'}. Read reviews.` : 'No reviews yet. Write a review.');
        const stars = document.createElement('span');
        stars.className = 'ps-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        const fill = document.createElement('span');
        fill.textContent = '★★★★★';
        fill.style.width = `${(average || 0) * 20}%`;
        stars.append(fill);
        link.append(stars);
        if (total && this.dataset.layout === 'detailed') {
          const score = document.createElement('strong');
          score.textContent = average.toFixed(2);
          link.append(score);
        }
        const count = document.createElement('span');
        count.className = 'ps-count';
        count.textContent = `${total} ${total === 1 ? 'review' : 'reviews'}`;
        if (total) link.append(count);
        link.addEventListener('click', event => {
          const target = document.getElementById(`poto-reviews-${this.dataset.product}`);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        });
        this.replaceChildren(link);
        this.setHidden(false);
      } catch { /* Leave unavailable ratings hidden. */ }
    }

    disconnectedCallback() { this.controller?.abort(); }
  });
}
